"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EDependencies = void 0;
var _dependenciesEGenerated = require("./dependenciesE.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var EDependencies = exports.EDependencies = {
  eDependencies: _dependenciesEGenerated.eDependencies,
  createUppercaseE: _factoriesAny.createUppercaseE
};